export const SET_COLLECTION_LIST = 'SET_COLLECTION_LIST';
export const DELETE_FROM_COLLECTION_LIST = 'DELETE_FROM_COLLECTION_LIST';
export const SET_COLLECTION_PLAYLIST = 'SET_COLLECTION_PLAYLIST';
export const ADD_COLLECTION_PLAYLIST = 'ADD_COLLECTION_PLAYLIST';
export const REMOVE_COLLECTION_PLAYLIST = 'REMOVE_COLLECTION_PLAYLIST';
export const SET_COLLECTION_ARRANGEMENT_PLAYLIST = 'SET_COLLECTION_ARRANGEMENT_PLAYLIST';
export const ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST = 'ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST';
export const REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST = 'REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST';
export const SET_COLLECTION_AUTHORS = 'SET_COLLECTION_AUTHORS';
export const SET_COLLECTION_GENRES = 'SET_COLLECTION_GENRES';
